import { Dispatch } from "redux";
import { LoginService } from "../../services/LoginService";
import { adminapi, orgapi } from "../../ApiNames";

export const fetchDataSuccess=(data:any) =>({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchImageDataSuccess=(imgdata:any) =>({
    type: 'FETCH_IMAGE_DATA_SUCCESS',
    payload: imgdata,
});
export const fetchdocDataSuccess=(docdata:any) =>({
    type: 'FETCH_DOC_DATA_SUCCESS',
    payload: docdata,
});
export const fetchUpdateDataSuccess=(updatedata:any) =>({
    type: 'FETCH_UPDATE_DATA_SUCCESS',
    payload: updatedata,
});
export const fetchCountryDataSuccess=(countrydata:any) =>({
    type: 'FETCH_COUNTRY_DATA_SUCCESS',
    payload: countrydata,
});
export const fetchDataViewSuccess=(dataview:any) =>({
    type: 'FETCH_VIEW_DATA_SUCCESS',
    payload: dataview,
});

export const fetchOrgdata = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid,q:1};
            const apiname = orgapi.orgprofile;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
// Countrydata
export const fetchcoundata = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname = adminapi.adcountry;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchCountryDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

//Attachments data
export const fetchDocdata = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid,q:5};
            const apiname = orgapi.orgdocuments;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchdocDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

//To upload image
export const UploadImageData = (fileToUpload: any, uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const apiname = orgapi.orgprofileimg;
            if (uid == null) {
                console.error('Error: uid is null or undefined');
                return;
            }
            // Create FormData and append the file
            const formData = new FormData();
            const fileName = `${uid}-${fileToUpload.name}`;
            formData.append('fileToUpload', fileToUpload, fileName);
            const response = await LoginService.uploadimage(apiname, formData);
            dispatch(fetchImageDataSuccess(response));
        } catch (error) {
            console.error('Error uploading image:', error);
        }
    };
};

//Edit Data
export const EditData = (nameoforg:any,nameofperson:any,email:any,designation:any,phonenumber:any,licenseno:any,ogrtype:any,website:any,address:any,city:any,state:any,country:any,pincode:any,licenseexpiry:any,orgsubtype:any,paypal:any,resume:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {nameoforg:nameoforg,nameofperson:nameofperson,email:email,designation:designation,phone:phonenumber,licenseno:licenseno,ogrtype:ogrtype,website:website,address:address,city:city,state:state,country:country,pincode:pincode,licenseexpiry:licenseexpiry,subogrtype:orgsubtype,paypalaccount:paypal,resume:resume,uid:uid};
            const apiname = orgapi.orgprofiledata;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchUpdateDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

//T0 view document
export const viewdata = (did:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { did:did,q:4};
            const apiname = orgapi.orgdeldata;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataViewSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
